module.exports = __webpack_public_path__ + "static/img/job4.bcc8c594.jpg";